import { SetLabelsRequest } from "@shared/dtos/requests/practiceRequests.dto"
import { LabelResponse } from "@shared/dtos/responses/practiceResponses.dto"
import { EntityType } from "@shared/enums/general"

import { axiosAuth } from "./generic/AxiosInterceptor/AxiosInterceptor"

export const getLabels = (practiceId: string): Promise<LabelResponse[]> => {
  return axiosAuth({
    url: `/practices/${practiceId}/labels`,
    method: "get",
  }).then((resp) => {
    return resp.data
  })
}

export const updateLabels = (practiceId: string, req: SetLabelsRequest): Promise<void> => {
  return axiosAuth({
    url: `/practices/${practiceId}/labels`,
    method: "put",
    data: req,
  }).then(() => undefined)
}

export const setLabels = (entityType: EntityType, entityId: string, labels: string[]): Promise<void> => {
  return axiosAuth({
    url: `/labels/${entityType}/${entityId}`,
    method: "put",
    data: { labels },
  }).then(() => undefined)
}
